import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ConcreteLIconProps {
  size?: number;
  color?: string;
}

const ConcreteLIcon: React.FC<ConcreteLIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-concretel">
    {
      <path d="M14.841 5.422h-9.575l0.155 13.157h13.313v-4.267h-3.941l0.047-8.889z"></path>

    }  </SvgIcon>
);

export default ConcreteLIcon;
